import React from "react";
import logoUrl from "@/assets/blacksilex-logo.png";

export function Logo({ className = "" }) {
  return (
    <img
      src={logoUrl}
      alt="BlackSilex"
      className={`block h-10 w-auto max-h-full shrink-0 select-none object-contain ${className}`}
      draggable="false"
      data-testid="brand-logo"
    />
  );
}
